<template>
  <div>
    <el-radio-group size="mini" v-model="quickDate" @change="dateChange">
      <el-radio-button label="0">今日</el-radio-button>
      <el-radio-button label="1">一周</el-radio-button>
      <el-radio-button label="2">一个月</el-radio-button>
      <el-radio-button label="3">三个月</el-radio-button>
      <el-radio-button label="4">一年</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import { GetDateTime, timeFun } from "@/js/public.js";
export default {
  data() {
    return {
      quickDate: "", //日期快选
      selectdDate: {
        start: "",
        end: ""
      }
    }
  },
  methods: {
    /**
     * radioChange 事件
     * @param {object} e radioChange事件返回值
     */
    dateChange (e) {
      console.log("组件change事件返回e：", e);
      console.log("组件change事件返回e：", typeof e);
      let date = "";
      const end = new Date();
      switch (e) {
        case "0":
          date = GetDateTime(-0, end);
          break;
        case "1":
          date = GetDateTime(-7, end);
          break;
        case "2":
          console.log("一个月");
          date = GetDateTime(-30, end);

          break;
        case "3":
          date = GetDateTime(-90, end);

          break;
        case "4":
          date = GetDateTime(-360, end);

          break;
      }
      this.selectdDate = {
        start: date,
        end: timeFun("count_dd", end)
      }
      this.$emit("quickSelectDateR", this.selectdDate);
    }
  }
}
</script>
<style lang="less" scoped>

</style>